
import { useState } from 'react';
import { WorkOrderCard } from './WorkOrderCard';
import { workOrders } from '../../../mocks/workOrders';

interface WorkOrderKanbanProps {
  filters: {
    status: string;
    priority: string;
    assignee: string;
    search: string;
  };
}

export function WorkOrderKanban({ filters }: WorkOrderKanbanProps) {
  const [draggedItem, setDraggedItem] = useState<string | null>(null);

  const columns = [
    { id: 'pending', title: 'Pending', color: 'bg-gray-100', count: 0 },
    { id: 'in_progress', title: 'In Progress', color: 'bg-blue-100', count: 0 },
    { id: 'completed', title: 'Completed', color: 'bg-green-100', count: 0 }
  ];

  const filteredWorkOrders = workOrders.filter(order => {
    const matchesStatus = filters.status === 'all' || order.status === filters.status;
    const matchesPriority = filters.priority === 'all' || order.priority === filters.priority;
    const matchesAssignee = filters.assignee === 'all' || order.assignedTo.toLowerCase().replace(' ', '-') === filters.assignee;
    const matchesSearch = filters.search === '' || 
      order.title.toLowerCase().includes(filters.search.toLowerCase()) ||
      order.asset.toLowerCase().includes(filters.search.toLowerCase()) ||
      order.id.toString().includes(filters.search.toLowerCase());
    
    return matchesStatus && matchesPriority && matchesAssignee && matchesSearch;
  });

  // Count items in each column
  columns.forEach(column => {
    column.count = filteredWorkOrders.filter(order => order.status === column.id).length;
  });

  const handleDragStart = (e: React.DragEvent, orderId: string) => {
    setDraggedItem(orderId);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e: React.DragEvent, newStatus: string) => {
    e.preventDefault();
    if (draggedItem) {
      // Here you would update the work order status
      console.log(`Moving work order ${draggedItem} to ${newStatus}`);
      setDraggedItem(null);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {columns.map(column => (
        <div
          key={column.id}
          className="bg-white rounded-lg border border-gray-200 overflow-hidden"
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, column.id)}
        >
          <div className={`${column.color} px-4 py-3 border-b border-gray-200`}>
            <div className="flex items-center justify-between">
              <h3 className="font-semibold text-gray-900">{column.title}</h3>
              <span className="bg-white text-gray-600 text-sm px-2 py-1 rounded-full">
                {column.count}
              </span>
            </div>
          </div>
          
          <div className="p-4 space-y-3 min-h-[400px]">
            {filteredWorkOrders
              .filter(order => order.status === column.id)
              .map(order => (
                <div
                  key={order.id}
                  draggable
                  onDragStart={(e) => handleDragStart(e, order.id.toString())}
                  className="cursor-move"
                >
                  <WorkOrderCard order={order} />
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
}